import WGS84Service from '@/services/wgs84ProjectionService';
import get from 'lodash/get';

export const getMapOverlayData = (data) => {
  const floorTwinData = data;

  if (!get(floorTwinData, 'overlayImageId')) {
    return null;
  }
  const ne = {
    lat: parseFloat(floorTwinData.neLat),
    lon: parseFloat(floorTwinData.neLon),
  };
  if (!WGS84Service.isValidWgs84(ne)) {
    return null;
  }
  const sw = {
    lat: parseFloat(floorTwinData.swLat),
    lon: parseFloat(floorTwinData.swLon),
  };
  if (!WGS84Service.isValidWgs84(sw)) {
    return null;
  }
  // https://docs.mapbox.com/mapbox-gl-js/style-spec/sources/#image
  // https://docs.mapbox.com/mapbox-gl-js/example/image-on-a-map/
  return {
    image: `${location.origin}/api/v1/upload/${floorTwinData.overlayImageId}`,
    coordinates: [
      [sw.lon, ne.lat],
      [ne.lon, ne.lat],
      [ne.lon, sw.lat],
      [sw.lon, sw.lat],
    ],
  };
};
